import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Project } from '@apps/projects/projects.state';

@Component({
  selector: 'app-project-number-display',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  template: `
    <ng-container>
      <span *ngIf="!(project.abacusProjectNumbers!.length > 0)" class="project-numbers"></span>
      <a
        *ngIf="project.abacusProjectNumbers?.length === 1 && isInternalUser"
        class="project-numbers"
        href="{{ project.abacusProjectReportingLinkBase + project.abacusProjectNumbers[0] }}"
        target="_blank"
        matTooltip="{{ project.abacusProjectNumbers.join(', ') }}"
      >
        {{ project.abacusProjectNumbers[0] }}{{ project.abacusProjectNumbers.length > 1 ? '...' : '' }}
      </a>
      <a
        *ngIf="project.abacusProjectNumbers!.length > 1 && isInternalUser"
        class="project-numbers"
        (click)="clicked.emit(projectIndex)"
        target="_blank"
        matTooltip="{{ project.abacusProjectNumbers.join(', ') }}"
      >
        {{ project.abacusProjectNumbers[0] }}{{ project.abacusProjectNumbers.length > 1 ? '...' : '' }}
      </a>
    </ng-container>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectNumberDisplayComponent {
  @Input({ required: true }) project: Project;
  @Input() isInternalUser: boolean;
  @Input() projectIndex = -1;
  @Output() clicked = new EventEmitter<number>();
}
